import { render, staticRenderFns } from "./liandongyun.vue?vue&type=template&id=2587af5d&scoped=true"
import script from "./liandongyun.vue?vue&type=script&lang=js"
export * from "./liandongyun.vue?vue&type=script&lang=js"
import style0 from "./liandongyun.vue?vue&type=style&index=0&id=2587af5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2587af5d",
  null
  
)

export default component.exports